"use client";

import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CodOrderDetailContent from "./codOrderDetailContent";

export default function CodOrderDetailView() {
  const navigate = useNavigate();
	const location = useLocation();
	const recieptno = location.state?.recieptno || null;

  return <CodOrderDetailContent navigate={navigate} recieptno={recieptno} />;
}
